import { defaultLocale } from '../constants/locales';

export const getPathnamePrefix = (locale: string | null) =>
  locale === defaultLocale || !locale ? undefined : locale;
